import type { ButtonHTMLAttributes, ReactNode } from 'react';
import Spinner from './Spinner';

type ButtonVariant = 'primary' | 'cta' | 'secondary' | 'ghost' | 'danger';

const STYLES: Record<ButtonVariant, string> = {
  // Only tokens tailwind.config.js defines: `ink-950`/`ink-800` don't exist,
  // and the label rendered white on nothing.
  primary:   'bg-ink text-white hover:bg-ink-2 border border-ink dark:bg-slate-100 dark:text-slate-900 dark:border-slate-100 dark:hover:bg-white',
  cta:       'bg-teal-500 text-white hover:bg-teal-600 border border-teal-500 shadow-sm',
  secondary: 'bg-white text-ink-900 hover:bg-canvas-100 border border-line-200',
  ghost:     'bg-transparent text-ink-600 hover:bg-canvas-100 border border-transparent',
  danger:    'bg-red-500 text-white hover:bg-red-600 border border-red-500',
};

export function Button({
  variant = 'secondary',
  loading = false,
  children,
  className = '',
  disabled,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  loading?: boolean;
  children: ReactNode;
}) {
  return (
    <button
      className={`inline-flex items-center justify-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${STYLES[variant]} ${className}`}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? <Spinner size="sm" /> : children}
    </button>
  );
}
